module.exports = function (e) {
  var t = {};

  function n(l) {
    if (t[l]) return t[l].exports;
    var r = t[l] = {
      i: l,
      l: !1,
      exports: {}
    };
    return e[l].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, l) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: l
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var l = Object.create(null);
    if (n.r(l), Object.defineProperty(l, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) n.d(l, r, function (t) {
      return e[t];
    }.bind(null, r));
    return l;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 50);
}([function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  t.INITIALISE = "INITIALISE", t.UPDATE_VIA_PROPS = "UPDATE_VIA_PROPS", t.SET_IS_DRAGGING = "SET_IS_DRAGGING", t.SET_OPTIONS_PANEL_OPEN = "SET_OPTIONS_PANEL_OPEN", t.SET_OPTIONS_PANEL_CLOSED = "SET_OPTIONS_PANEL_CLOSED", t.SET_SINGLESELECT_OPTIONS = "SET_SINGLESELECT_OPTIONS", t.SET_MULTISELECT_OPTIONS = "SET_MULTISELECT_OPTIONS", t.SET_OPTIONS_PANEL_CLOSED_NO_SELECTION = "SET_OPTIONS_PANEL_CLOSED_NO_SELECTION", t.SET_OPTIONS_PANEL_CLOSED_ONBLUR = "SET_OPTIONS_PANEL_CLOSED_ONBLUR", t.SET_NEXT_SELECTED_INDEX = "SET_NEXT_SELECTED_INDEX", t.SET_NEXT_SELECTED_INDEX_ALPHA_NUMERIC = "SET_NEXT_SELECTED_INDEX_ALPHA_NUMERIC";
}, function (e, t, n) {
  e.exports = n(37)();
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var l = n(38);
  Object.defineProperty(t, "ReactResponsiveSelectProps", {
    enumerable: !0,
    get: function get() {
      return l.ReactResponsiveSelectProps;
    }
  });
  var r = n(35);
  Object.defineProperty(t, "MultiSelectProps", {
    enumerable: !0,
    get: function get() {
      return r.MultiSelectProps;
    }
  });
  var o = n(34);
  Object.defineProperty(t, "MultiSelectOptionProps", {
    enumerable: !0,
    get: function get() {
      return o.MultiSelectOptionProps;
    }
  });
  var a = n(33);
  Object.defineProperty(t, "SingleSelectProps", {
    enumerable: !0,
    get: function get() {
      return a.SingleSelectProps;
    }
  });
  var i = n(32);
  Object.defineProperty(t, "SingleSelectOptionProps", {
    enumerable: !0,
    get: function get() {
      return i.SingleSelectOptionProps;
    }
  });
}, function (e, t) {
  e.exports = require("singleline");
}, function (e, t) {
  e.exports = require("lodash.isequal");
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.nextValidIndex = function (e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "INCREMENT",
        l = e.options,
        r = l.reduce(function (e, t, n) {
      return t.optHeader || e.push(n), e;
    }, []),
        o = -1 === r.indexOf(t);

    if (o && "INCREMENT" === n) {
      var a = l[t + 1] && !l[t + 1].optHeader;
      return a ? t + 1 : r[0];
    }

    if (o && "DECREMENT" === n) {
      var i = l[t - 1] && !l[t - 1].optHeader;
      return i ? t - 1 : r[r.length - 1];
    }

    return t;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = {
    multiselect: !1,
    name: void 0,
    options: [],
    isDragging: !1,
    isOptionsPanelOpen: !1,
    altered: !1,
    singleSelectInitialIndex: 0,
    singleSelectSelectedIndex: 0,
    singleSelectSelectedOption: {},
    nextPotentialSelectionIndex: 0,
    multiSelectInitialSelectedIndexes: [0],
    multiSelectSelectedOptions: {
      options: []
    },
    multiSelectSelectedIndexes: []
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    var t = e.state,
        n = e.ReactResponsiveSelectClassRef,
        o = e.type,
        a = t.isOptionsPanelOpen,
        i = t.disabled;
    t.hasOptHeaders;
    if (i) return;
    n.updateState({
      type: r.SET_NEXT_SELECTED_INDEX,
      optionIndex: (0, l.default)(o, t)
    }), !1 === a && n.updateState({
      type: r.SET_OPTIONS_PANEL_OPEN
    });
  };

  var l = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(n(41)),
      r = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t.default = e, t;
  }(n(0));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t.default = e, t;
  }(n(0));

  t.default = function (e) {
    var t = e.event,
        n = e.state,
        r = e.props,
        o = e.ReactResponsiveSelectClassRef,
        a = n.multiselect,
        i = n.isOptionsPanelOpen,
        u = n.nextPotentialSelectionIndex,
        s = n.disabled,
        c = n.options;

    if (!s) {
      var d = parseFloat(t.target.getAttribute("data-key"));
      c[d] && !0 === c[d].disabled || c[d] && !0 === c[d].optHeader || (a ? o.updateState({
        type: l.SET_MULTISELECT_OPTIONS,
        optionIndex: u
      }) : o.updateState({
        type: l.SET_SINGLESELECT_OPTIONS,
        optionIndex: u
      }), i ? t.stopPropagation() : r.onSubmit());
    }
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    var t = e.event,
        n = e.state,
        o = e.ReactResponsiveSelectClassRef,
        a = n.multiselect,
        i = n.isOptionsPanelOpen,
        u = n.isDragging,
        s = n.disabled,
        c = n.options;
    if (s) return;

    if (!1 === u) {
      if (t.preventDefault(), t && (0, l.default)(t.target, "rrs__options")) return;
      var d = parseFloat(t.target.getAttribute("data-key"));
      if (c[d] && !0 === c[d].disabled || c[d] && !0 === c[d].optHeader) return;
      if ((0, l.default)(t.target, "rrs__option")) return void o.updateState({
        type: a ? r.SET_MULTISELECT_OPTIONS : r.SET_SINGLESELECT_OPTIONS,
        optionIndex: d
      });
      if (i && ((0, l.default)(t.target, "rrs__label") || (0, l.default)(t.target, "rrs"))) return void o.updateState({
        type: r.SET_OPTIONS_PANEL_CLOSED_NO_SELECTION
      }, function () {
        return o.focusButton();
      });
      o.updateState({
        type: i ? r.SET_OPTIONS_PANEL_CLOSED : r.SET_OPTIONS_PANEL_OPEN
      }, function (e) {
        !1 === e.isOptionsPanelOpen && o.focusButton();
      });
    }
  };

  var l = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(n(45)),
      r = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t.default = e, t;
  }(n(0));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.singleSelectBroadcastChange = t.multiSelectBroadcastChange = void 0;
  var l = o(n(47)),
      r = o(n(46));

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  t.multiSelectBroadcastChange = l.default, t.singleSelectBroadcastChange = r.default;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t.default = e, t;
  }(n(0));

  t.default = function (e) {
    var t = e.event,
        n = e.state,
        r = e.ReactResponsiveSelectClassRef,
        o = n.options;

    if (!n.disabled) {
      var a = o.map(function (e) {
        return e.text.toLowerCase().charAt(0);
      }).indexOf(t.key);
      a > -1 && r.updateState({
        type: l.SET_NEXT_SELECTED_INDEX_ALPHA_NUMERIC,
        optionIndex: a
      });
    }
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var l = t[n];
        l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(e, l.key, l);
      }
    }

    return function (t, n, l) {
      return n && e(t.prototype, n), l && e(t, l), t;
    };
  }(),
      r = n(5),
      o = u(r),
      a = u(n(3)),
      i = n(2);

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var s = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var e = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));

      return e.optionRef = o.default.createRef(), e;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, r.Component), l(t, [{
      key: "componentDidUpdate",
      value: function value() {
        var e = this.props,
            t = e.index,
            n = e.isOptionsPanelOpen,
            l = e.nextPotentialSelectionIndex,
            r = e.optionsContainerRef,
            o = e.optHeaderLabel;

        if (t === l && n && (this.optionRef.current.focus(), "" !== o)) {
          var a = Math.ceil(this.optionRef.current.getBoundingClientRect().top - r.current.getBoundingClientRect().top);
          this.scrollOffset = this.scrollOffset || Math.ceil(document.querySelector(".rrs__option--header").getBoundingClientRect().height), a < this.scrollOffset && r.current.scroll(0, Math.floor(r.current.scrollTop - this.scrollOffset));
        }
      }
    }, {
      key: "isDisabled",
      value: function value(e) {
        return e.disabled || e.optHeader;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.index,
            n = e.nextPotentialSelectionIndex,
            l = e.option,
            r = e.singleSelectSelectedIndex,
            i = e.optHeaderLabel;
        return o.default.createElement("li", {
          role: "menuitem",
          tabIndex: "-1",
          "aria-disabled": this.isDisabled(l) ? "true" : "false",
          "aria-label": "\n          " + (l.text || l.markup && l.markup.textNode) + " " + ("" !== i ? " of " + i : "") + "\n        ",
          "data-key": t,
          index: t,
          ref: this.optionRef,
          className: (0, a.default)("\n          rrs__option\n          " + (r === t ? "rrs__option--selected" : "") + "\n          " + (n === t ? "rrs__option--next-selection" : "") + "\n          " + (!0 === l.disabled ? "rrs__option--disabled" : "") + "\n          " + (!0 === l.optHeader ? "rrs__option--header" : "") + "\n        ")
        }, l.markup || l.text);
      }
    }]), t;
  }();

  t.default = s, s.propTypes = i.SingleSelectOptionProps;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var l = t[n];
        l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(e, l.key, l);
      }
    }

    return function (t, n, l) {
      return n && e(t.prototype, n), l && e(t, l), t;
    };
  }(),
      r = n(5),
      o = s(r),
      a = s(n(3)),
      i = n(2),
      u = s(n(13));

  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var e = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));

      return e.optionsButton = o.default.createRef(), e.optionsContainer = o.default.createRef(), e;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, r.Component), l(t, [{
      key: "componentDidUpdate",
      value: function value(e) {
        var t = this.props,
            n = t.isOptionsPanelOpen,
            l = t.nextPotentialSelectionIndex,
            r = t.selectBoxRef;
        !n && e.isOptionsPanelOpen && r.contains(document.activeElement) && this.optionsButton.current.focus(), n && -1 === l && this.optionsButton.current.focus();
      }
    }, {
      key: "getCustomLabel",
      value: function value() {
        var e = this.props,
            t = e.prefix,
            n = e.name,
            l = e.singleSelectSelectedOption,
            r = e.caretIcon,
            a = e.customLabelText;
        return o.default.createElement("div", {
          className: "rrs__label"
        }, o.default.createElement("span", {
          "aria-label": (t ? t + " " : "") + l.text + " selected",
          className: "rrs__label__text",
          id: "rrs-" + n + "-label"
        }, a), r && r);
      }
    }, {
      key: "getDefaultLabel",
      value: function value() {
        var e = this.props,
            t = e.prefix,
            n = e.singleSelectSelectedOption,
            l = e.name,
            r = e.caretIcon,
            a = e.singleSelectSelectedIndex,
            i = e.noSelectionLabel;
        return -1 === a ? o.default.createElement("div", {
          className: "rrs__label"
        }, o.default.createElement("span", {
          "aria-label": i,
          className: "rrs__label__text",
          id: "rrs-" + l + "-label"
        }, t && o.default.createElement("span", null, t), i), r && r) : o.default.createElement("div", {
          className: "rrs__label"
        }, o.default.createElement("span", {
          "aria-label": (t ? t + " " : "") + n.text + " selected",
          className: "rrs__label__text",
          id: "rrs-" + l + "-label"
        }, t && o.default.createElement("span", null, t), n.text ? n.text : o.default.createElement("div", null, " ")), r && r);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            t = this.props,
            n = t.customLabelText,
            l = t.disabled,
            r = t.isOptionsPanelOpen,
            i = t.isDragging,
            s = t.name,
            c = t.nextPotentialSelectionIndex,
            d = t.options,
            f = t.singleSelectSelectedIndex,
            p = t.singleSelectSelectedOption,
            S = "";
        return o.default.createElement("div", null, o.default.createElement("div", {
          role: "button",
          tabIndex: "0",
          "aria-disabled": l,
          "aria-haspopup": "true",
          "aria-expanded": r,
          "aria-controls": "rrs-" + s + "-menu",
          ref: this.optionsButton,
          className: (0, a.default)("\n            rrs__button\n            " + (!0 === l ? "rrs__button--disabled" : "") + "\n          ")
        }, n && this.getCustomLabel(), !n && this.getDefaultLabel(), s && o.default.createElement("input", {
          type: "hidden",
          name: s,
          value: p.value
        })), o.default.createElement("ul", {
          id: "rrs-" + s + "-menu",
          "aria-labelledby": "rrs-" + s + "-label",
          role: "menu",
          className: "rrs__options",
          ref: this.optionsContainer
        }, d.length > 0 && d.map(function (t, n) {
          return t.optHeader && (S = t.text || t.markup.textContent), o.default.createElement(u.default, {
            key: n,
            optHeaderLabel: S,
            optionsContainerRef: e.optionsContainer,
            index: n,
            isDragging: i,
            isOptionsPanelOpen: r,
            option: t,
            singleSelectSelectedIndex: f,
            nextPotentialSelectionIndex: c
          });
        })));
      }
    }]), t;
  }();

  t.default = c, c.propTypes = i.SingleSelectProps;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var l = t[n];
        l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(e, l.key, l);
      }
    }

    return function (t, n, l) {
      return n && e(t.prototype, n), l && e(t, l), t;
    };
  }(),
      r = n(5),
      o = u(r),
      a = u(n(3)),
      i = n(2);

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var s = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var e = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));

      return e.optionRef = o.default.createRef(), e;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, r.Component), l(t, [{
      key: "componentDidUpdate",
      value: function value() {
        var e = this.props,
            t = e.index,
            n = e.isOptionsPanelOpen,
            l = e.nextPotentialSelectionIndex,
            r = e.optionsContainerRef,
            o = e.optHeaderLabel;

        if (t === l && n && (this.optionRef.current.focus(), "" !== o)) {
          var a = Math.ceil(this.optionRef.current.getBoundingClientRect().top - r.current.getBoundingClientRect().top);
          this.scrollOffset = this.scrollOffset || Math.ceil(document.querySelector(".rrs__option--header").getBoundingClientRect().height), a < this.scrollOffset && r.current.scroll(0, Math.floor(r.current.scrollTop - this.scrollOffset));
        }
      }
    }, {
      key: "isDisabled",
      value: function value(e) {
        return e.disabled || e.optHeader;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.index,
            n = e.multiSelectSelectedIndexes,
            l = e.nextPotentialSelectionIndex,
            r = e.option,
            i = e.optHeaderLabel,
            u = n.some(function (e) {
          return e === t;
        });
        return o.default.createElement("li", {
          role: "checkbox",
          tabIndex: "-1",
          "aria-checked": u,
          "aria-label": "\n        " + (r.text || r.markup && r.markup.textNode) + " " + ("" !== i ? " of " + i : "") + "\n      ",
          "aria-live": "assertive",
          "aria-disabled": this.isDisabled(r) ? "true" : "false",
          "data-key": t,
          index: t,
          ref: this.optionRef,
          className: (0, a.default)("\n          rrs__option\n          " + (u ? "rrs__option--selected" : "") + "\n          " + (l === t ? "rrs__option--next-selection" : "") + "\n          " + (!0 === r.disabled ? "rrs__option--disabled" : "") + "\n          " + (!0 === r.optHeader ? "rrs__option--header" : "") + "\n        ")
        }, r.markup || r.text);
      }
    }]), t;
  }();

  t.default = s, s.propTypes = i.MultiSelectOptionProps;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var l = t[n];
        l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(e, l.key, l);
      }
    }

    return function (t, n, l) {
      return n && e(t.prototype, n), l && e(t, l), t;
    };
  }(),
      r = n(5),
      o = s(r),
      a = s(n(3)),
      i = (s(n(4)), n(2)),
      u = s(n(15));

  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var e = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));

      return e.optionsButton = o.default.createRef(), e.optionsContainer = o.default.createRef(), e;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, r.Component), l(t, [{
      key: "componentDidUpdate",
      value: function value(e) {
        var t = this.props,
            n = t.isOptionsPanelOpen,
            l = t.selectBoxRef;
        !n && e.isOptionsPanelOpen && l.contains(document.activeElement) && this.optionsButton.current.focus();
      }
    }, {
      key: "getAriaLabel",
      value: function value() {
        var e = this.props,
            t = e.multiSelectSelectedOptions,
            n = e.prefix,
            l = t.options.length;
        return (0, a.default)("\n      Checkbox group " + (n ? n + " " : "") + " has\n      " + l + " item" + (1 === l ? "" : "s") + " selected.\n      Selected option" + (1 === l ? "" : "s") + " " + (1 === l ? "is" : "are") + "\n      " + t.options.map(function (e) {
          return e.text;
        }).join(" and ") + "\n    ");
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            t = this.props,
            n = t.caretIcon,
            l = t.customLabelText,
            r = t.disabled,
            i = t.isDragging,
            s = t.isOptionsPanelOpen,
            c = t.multiSelectSelectedIndexes,
            d = t.multiSelectSelectedOptions,
            f = t.name,
            p = t.options,
            S = t.nextPotentialSelectionIndex,
            _ = t.prefix,
            O = "";
        return o.default.createElement("div", null, o.default.createElement("div", {
          role: "button",
          tabIndex: "0",
          "aria-disabled": r,
          "aria-haspopup": "true",
          "aria-expanded": s,
          "aria-controls": "rrs-" + f + "-menu",
          ref: this.optionsButton,
          className: (0, a.default)("\n            rrs__button\n            " + (!0 === r ? "rrs__button--disabled" : "") + "\n          ")
        }, l && o.default.createElement("div", {
          className: "rrs__label"
        }, o.default.createElement("span", {
          "aria-label": this.getAriaLabel(),
          className: "rrs__label__text",
          id: "rrs-" + f + "-label"
        }, l), n && n), !l && o.default.createElement("div", {
          className: "rrs__label"
        }, o.default.createElement("span", {
          "aria-label": this.getAriaLabel(),
          className: "rrs__label__text",
          id: "rrs-" + f + "-label"
        }, o.default.createElement("span", {
          className: "rrs__multiselect-label"
        }, o.default.createElement("span", {
          className: "rrs__multiselect-label__text"
        }, (_ ? _ + " " : "") + "\n                  " + (d.options.length > 0 ? d.options[0].text : "")), d.options.length > 1 && o.default.createElement("span", {
          className: "rrs__multiselect-label__badge"
        }, "+ " + (d.options.length - 1)))), n && n), f && o.default.createElement("input", {
          type: "hidden",
          name: f,
          value: [d.options.map(function (e) {
            return e.value;
          })].join(",")
        })), o.default.createElement("ul", {
          id: "rrs-" + f + "-menu",
          "aria-labelledby": "rrs-" + f + "-label",
          role: "menu",
          className: "rrs__options",
          ref: this.optionsContainer
        }, p.length > 0 && p.map(function (t, n) {
          return t.optHeader && (O = t.text || t.markup.textContent), o.default.createElement(u.default, {
            key: n,
            optHeaderLabel: O,
            optionsContainerRef: e.optionsContainer,
            index: n,
            option: t,
            isDragging: i,
            isOptionsPanelOpen: s,
            multiSelectSelectedIndexes: c,
            nextPotentialSelectionIndex: S
          });
        })));
      }
    }]), t;
  }();

  t.default = c, c.propTypes = i.MultiSelectProps;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var l in n) Object.prototype.hasOwnProperty.call(n, l) && (e[l] = n[l]);
    }

    return e;
  };

  t.default = function (e) {
    return l({}, e, {
      multiSelectSelectedIndexes: [].concat(function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];

          return n;
        }

        return Array.from(e);
      }(r.default.multiSelectSelectedIndexes)),
      multiSelectSelectedOptions: l({}, r.default.multiSelectSelectedOptions)
    });
  };

  var r = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(n(7));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var l in n) Object.prototype.hasOwnProperty.call(n, l) && (e[l] = n[l]);
    }

    return e;
  };

  t.default = function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = -1 === t ? 0 : t;

    if (e.options[n] && e.options[n].optHeader) {
      var r = function (e) {
        if (e.singleSelectSelectedOption) return e.singleSelectSelectedOption;
        return e.options.reduce(function (e, t) {
          return t.optHeader || e.push(t), e;
        }, [])[0];
      }(e);

      return l({
        name: e.name
      }, r);
    }

    if (!e.noSelectionLabel) return l({
      name: e.name
    }, e.options[n]);
    return t > -1 ? l({
      name: e.name
    }, e.options[t]) : {
      name: e.name,
      text: e.noSelectionLabel,
      value: "null"
    };
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var l in n) Object.prototype.hasOwnProperty.call(n, l) && (e[l] = n[l]);
    }

    return e;
  };

  t.default = function (e) {
    var t = function (e) {
      return e.options.reduce(function (e, t, n) {
        return t.optHeader || e.push({
          option: t,
          index: n
        }), e;
      }, [])[0];
    }(e),
        n = t.option,
        r = t.index;

    return l({}, e, {
      multiSelectSelectedIndexes: [r],
      multiSelectSelectedOptions: {
        options: [l({
          name: e.name
        }, n)]
      },
      nextPotentialSelectionIndex: r
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var l in n) Object.prototype.hasOwnProperty.call(n, l) && (e[l] = n[l]);
    }

    return e;
  };

  t.isAltered = o, t.default = function (e) {
    return l({}, e, {
      altered: o(e)
    });
  };

  var r = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(n(4));

  function o(e) {
    return e.multiselect ? !(0, r.default)(e.multiSelectInitialSelectedIndexes, e.multiSelectSelectedIndexes) : e.singleSelectSelectedIndex !== e.singleSelectInitialIndex;
  }
}, function (e, t, n) {
  "use strict";

  function l(e) {
    if (Array.isArray(e)) {
      for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];

      return n;
    }

    return Array.from(e);
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e, t) {
    return {
      options: [].concat(l(e.multiSelectSelectedOptions.options.slice(0, t)), l(e.multiSelectSelectedOptions.options.slice(t + 1)))
    };
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var l in n) Object.prototype.hasOwnProperty.call(n, l) && (e[l] = n[l]);
    }

    return e;
  };

  t.default = function (e, t) {
    return {
      options: [].concat(function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];

          return n;
        }

        return Array.from(e);
      }(e.multiSelectSelectedOptions.options), [l({
        name: e.name
      }, e.options[t])])
    };
  };
}, function (e, t, n) {
  "use strict";

  function l(e) {
    if (Array.isArray(e)) {
      for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];

      return n;
    }

    return Array.from(e);
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e, t) {
    return [].concat(l(e.multiSelectSelectedIndexes.slice(0, t)), l(e.multiSelectSelectedIndexes.slice(t + 1)));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e, t) {
    return [].concat(function (e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];

        return n;
      }

      return Array.from(e);
    }(e.multiSelectSelectedIndexes), [t]);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var l in n) Object.prototype.hasOwnProperty.call(n, l) && (e[l] = n[l]);
    }

    return e;
  };

  t.default = function (e) {
    var t = void 0;

    if (!e.noSelectionLabel) {
      if (e.selectedValues) t = e.options.filter(function (t) {
        return e.selectedValues.some(function (e) {
          return e === t.value;
        });
      }).map(function (t) {
        return l({
          name: e.name
        }, t);
      });else {
        var n = e.options[0] && e.options[0].optHeader ? function (e) {
          if (e.multiSelectSelectedOptions) return e.multiSelectSelectedOptions;
          return e.options.reduce(function (e, t) {
            return t.optHeader || e.push(t), e;
          }, [])[0];
        }(e) : e.options[0];
        t = [l({
          name: e.name
        }, n)];
      }
      return t;
    }

    return t = e.selectedValues && e.selectedValues.length > 0 ? e.options.filter(function (t) {
      return e.selectedValues.some(function (e) {
        return e === t.value;
      });
    }).map(function (t) {
      return l({
        name: e.name
      }, t);
    }) : [{
      name: e.name,
      text: e.noSelectionLabel,
      value: "null"
    }];
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
        n = arguments[2],
        r = e.options.map(function (e, n) {
      return t.some(function (t) {
        return e.value === t;
      }) ? n : void 0;
    }).filter(function (e) {
      return void 0 !== e;
    }),
        o = n ? [] : [(0, l.nextValidIndex)(e, 0)];
    return r.length ? r : o;
  };
  var l = n(6);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    var t = e.options,
        n = e.selectedValue,
        l = e.noSelectionLabel,
        r = n ? t.map(function (e) {
      return e.value;
    }).indexOf(n) : -1;
    return r > -1 || l ? r : 0;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.resetMultiSelectState = t.getSingleSelectSelectedOption = t.getInitialMultiSelectOption = t.mergeIsAlteredState = t.removeMultiSelectOption = t.addMultiSelectOption = t.removeMultiSelectIndex = t.addMultiSelectIndex = t.getMultiSelectInitialSelectedOptions = t.getMultiSelectSelectedValueIndexes = t.getSelectedValueIndex = void 0;
  var l = S(n(27)),
      r = S(n(26)),
      o = S(n(25)),
      a = S(n(24)),
      i = S(n(23)),
      u = S(n(22)),
      s = S(n(21)),
      c = S(n(20)),
      d = S(n(19)),
      f = S(n(18)),
      p = S(n(17));

  function S(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  t.getSelectedValueIndex = l.default, t.getMultiSelectSelectedValueIndexes = r.default, t.getMultiSelectInitialSelectedOptions = o.default, t.addMultiSelectIndex = a.default, t.removeMultiSelectIndex = i.default, t.addMultiSelectOption = u.default, t.removeMultiSelectOption = s.default, t.mergeIsAlteredState = c.default, t.getInitialMultiSelectOption = d.default, t.getSingleSelectSelectedOption = f.default, t.resetMultiSelectState = p.default;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var l in n) Object.prototype.hasOwnProperty.call(n, l) && (e[l] = n[l]);
    }

    return e;
  };

  t.default = function (e, t) {
    switch (t.type) {
      case r.UPDATE_VIA_PROPS:
      case r.INITIALISE:
        var n = (0, a.getSelectedValueIndex)(t.value),
            i = (0, a.getMultiSelectSelectedValueIndexes)(t.value, t.value.selectedValues, t.value.noSelectionLabel);
        return l({}, e, {
          hasOptHeaders: t.value.options.some(function (e) {
            return !0 === e.optHeader;
          }),
          multiselect: t.value.multiselect || !1,
          noSelectionLabel: t.value.noSelectionLabel,
          name: t.value.name,
          options: t.value.options,
          altered: t.value.altered || !1,
          disabled: t.value.disabled || !1,
          singleSelectInitialIndex: n,
          singleSelectSelectedIndex: n,
          singleSelectSelectedOption: (0, a.getSingleSelectSelectedOption)(t.value, n),
          nextPotentialSelectionIndex: e.nextPotentialSelectionIndex ? e.nextPotentialSelectionIndex : n,
          multiSelectInitialSelectedIndexes: i,
          multiSelectSelectedIndexes: i,
          multiSelectSelectedOptions: {
            options: (0, a.getMultiSelectInitialSelectedOptions)(t.value, i)
          }
        });

      case r.SET_IS_DRAGGING:
        return l({}, e, {
          isDragging: t.value
        });

      case r.SET_OPTIONS_PANEL_OPEN:
        var u = l({}, e, {
          isOptionsPanelOpen: !0,
          nextPotentialSelectionIndex: e.multiselect ? e.multiSelectSelectedIndexes.length ? (0, o.nextValidIndex)(e, e.multiSelectSelectedIndexes[0]) : (0, o.nextValidIndex)(e, 0) : (0, o.nextValidIndex)(e, e.nextPotentialSelectionIndex),
          singleSelectSelectedOption: (0, a.getSingleSelectSelectedOption)(e, e.nextPotentialSelectionIndex)
        });
        return (0, a.mergeIsAlteredState)(u);

      case r.SET_OPTIONS_PANEL_CLOSED:
        var s = l({}, e, {
          isOptionsPanelOpen: !1,
          singleSelectSelectedIndex: e.nextPotentialSelectionIndex,
          singleSelectSelectedOption: (0, a.getSingleSelectSelectedOption)(e, e.nextPotentialSelectionIndex)
        });
        return (0, a.mergeIsAlteredState)(s);

      case r.SET_OPTIONS_PANEL_CLOSED_NO_SELECTION:
      case r.SET_OPTIONS_PANEL_CLOSED_ONBLUR:
        return l({}, e, {
          nextPotentialSelectionIndex: e.singleSelectSelectedIndex,
          isOptionsPanelOpen: !1
        });

      case r.SET_NEXT_SELECTED_INDEX:
        return l({}, e, {
          nextPotentialSelectionIndex: t.optionIndex
        });

      case r.SET_NEXT_SELECTED_INDEX_ALPHA_NUMERIC:
        return l({}, e, {
          isOptionsPanelOpen: !0,
          nextPotentialSelectionIndex: t.optionIndex
        });

      case r.SET_SINGLESELECT_OPTIONS:
        var c = l({}, e, {
          nextPotentialSelectionIndex: t.optionIndex,
          singleSelectSelectedIndex: t.optionIndex,
          isOptionsPanelOpen: !1,
          singleSelectSelectedOption: (0, a.getSingleSelectSelectedOption)(e, t.optionIndex)
        });
        return (0, a.mergeIsAlteredState)(c);

      case r.SET_MULTISELECT_OPTIONS:
        if (!e.noSelectionLabel) {
          var d = 0 === e.multiSelectSelectedIndexes[0] && 1 === e.multiSelectSelectedIndexes.length,
              f = e.multiSelectSelectedIndexes.length > 0 && !d && 0 === t.optionIndex,
              p = d && 0 !== t.optionIndex;

          if (f) {
            var S = (0, a.getInitialMultiSelectOption)(e);
            return (0, a.mergeIsAlteredState)(S);
          }

          p && (e = (0, a.resetMultiSelectState)(e));
        }

        e.noSelectionLabel && e.multiSelectSelectedOptions.options[0].text === e.noSelectionLabel && (e.multiSelectSelectedOptions.options = []);

        var _ = (0, o.nextValidIndex)(e, t.optionIndex),
            O = e.multiSelectSelectedIndexes.indexOf(_),
            v = l({}, e, {
          nextPotentialSelectionIndex: _,
          multiSelectSelectedIndexes: -1 === O ? (0, a.addMultiSelectIndex)(e, _) : (0, a.removeMultiSelectIndex)(e, O),
          multiSelectSelectedOptions: -1 === O ? (0, a.addMultiSelectOption)(e, _) : (0, a.removeMultiSelectOption)(e, O)
        });

        if (0 === v.multiSelectSelectedOptions.options.length) if (e.noSelectionLabel) {
          var b = (0, a.getMultiSelectSelectedValueIndexes)(e, e.selectedValues);
          v = l({}, v, {
            nextPotentialSelectionIndex: e.hasOptHeaders ? (0, o.nextValidIndex)(e, -1) : -1,
            multiSelectSelectedOptions: {
              options: (0, a.getMultiSelectInitialSelectedOptions)(e, b)
            }
          });
        } else v = (0, a.getInitialMultiSelectOption)(e);
        return (0, a.mergeIsAlteredState)(v);

      default:
        return e;
    }
  };

  var r = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t.default = e, t;
  }(n(0)),
      o = n(6),
      a = n(28);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    var t = e.state,
        n = e.props,
        l = n.multiselect,
        r = n.customLabelRenderer,
        o = t.multiSelectSelectedOptions,
        a = t.singleSelectSelectedOption;
    return !!r && r(l ? o : a);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  "function" == typeof Symbol && Symbol.iterator;

  t.default = function (e, t, n) {
    0;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.SingleSelectOptionProps = void 0;

  var l = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(n(1));

  t.SingleSelectOptionProps = {
    index: l.default.number.isRequired,
    isOptionsPanelOpen: l.default.bool.isRequired,
    nextPotentialSelectionIndex: l.default.number,
    option: l.default.shape({
      text: l.default.string.isRequired,
      value: l.default.string,
      optHeader: l.default.bool,
      markup: l.default.element,
      disabled: l.default.bool
    }).isRequired,
    singleSelectSelectedIndex: l.default.number
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.SingleSelectProps = void 0;

  var l = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(n(1));

  t.SingleSelectProps = {
    altered: l.default.bool,
    caretIcon: l.default.oneOfType([l.default.string, l.default.element]),
    customLabelText: l.default.oneOfType([l.default.string, l.default.bool, l.default.element]),
    disabled: l.default.bool,
    singleSelectInitialIndex: l.default.number,
    singleSelectSelectedIndex: l.default.number,
    singleSelectSelectedOption: l.default.shape({
      text: l.default.string,
      value: l.default.string
    }),
    isDragging: l.default.bool,
    isOptionsPanelOpen: l.default.bool,
    name: l.default.string,
    nextPotentialSelectionIndex: l.default.number,
    onSubmit: l.default.func,
    options: l.default.arrayOf(l.default.shape({
      text: l.default.string.isRequired,
      value: l.default.string,
      optHeader: l.default.bool
    })).isRequired,
    prefix: l.default.string,
    noSelectionLabel: l.default.string,
    selectedValue: l.default.string
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.MultiSelectOptionProps = void 0;

  var l = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(n(1));

  t.MultiSelectOptionProps = {
    index: l.default.number.isRequired,
    isOptionsPanelOpen: l.default.bool.isRequired,
    multiSelectSelectedIndexes: l.default.arrayOf(l.default.number),
    nextPotentialSelectionIndex: l.default.number,
    option: l.default.shape({
      text: l.default.string,
      value: l.default.string,
      optHeader: l.default.bool,
      markup: l.default.element,
      disabled: l.default.bool
    }).isRequired
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.MultiSelectProps = void 0;

  var l = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(n(1));

  t.MultiSelectProps = {
    altered: l.default.bool,
    caretIcon: l.default.oneOfType([l.default.string, l.default.element]),
    customLabelText: l.default.oneOfType([l.default.string, l.default.bool, l.default.element]),
    disabled: l.default.bool,
    multiSelectInitialSelectedIndexes: l.default.arrayOf(l.default.number),
    multiSelectSelectedIndexes: l.default.arrayOf(l.default.number),
    multiSelectSelectedOptions: l.default.shape({
      altered: l.default.bool,
      options: l.default.arrayOf(l.default.shape({
        name: l.default.string,
        text: l.default.string,
        value: l.default.string,
        markup: l.default.object
      }))
    }),
    isDragging: l.default.bool,
    isOptionsPanelOpen: l.default.bool,
    name: l.default.string,
    nextPotentialSelectionIndex: l.default.number,
    onSubmit: l.default.func,
    options: l.default.arrayOf(l.default.shape({
      text: l.default.string,
      value: l.default.string,
      optHeader: l.default.bool
    })).isRequired,
    prefix: l.default.string
  };
}, function (e, t, n) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, n) {
  "use strict";

  var l = n(36);

  function r() {}

  e.exports = function () {
    function e(e, t, n, r, o, a) {
      if (a !== l) {
        var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw i.name = "Invariant Violation", i;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t
    };
    return n.checkPropTypes = r, n.PropTypes = n, n;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ReactResponsiveSelectProps = void 0;

  var l = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(n(1));

  t.ReactResponsiveSelectProps = {
    caretIcon: l.default.oneOfType([l.default.string, l.default.element]),
    customLabelRenderer: l.default.func,
    disabled: l.default.bool,
    multiselect: l.default.bool,
    name: l.default.string.isRequired,
    onChange: l.default.func,
    options: l.default.arrayOf(l.default.shape({
      text: l.default.string,
      value: l.default.string,
      optHeader: l.default.bool
    })).isRequired,
    onSubmit: l.default.func,
    prefix: l.default.string,
    selectedValue: l.default.string,
    noSelectionLabel: l.default.string,
    selectedValues: l.default.arrayOf(l.default.string.isRequired)
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    var t = e.state,
        n = e.ReactResponsiveSelectClassRef;
    if (t.disabled) return;
    n.updateState({
      type: l.SET_IS_DRAGGING,
      value: !1
    });
  };

  var l = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t.default = e, t;
  }(n(0));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    var t = e.state,
        n = e.ReactResponsiveSelectClassRef,
        r = t.isDragging;
    if (t.disabled) return;
    r || n.updateState({
      type: l.SET_IS_DRAGGING,
      value: !0
    });
  };

  var l = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t.default = e, t;
  }(n(0));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e, t) {
    var n = t.isOptionsPanelOpen,
        r = t.nextPotentialSelectionIndex,
        o = t.options;

    switch (e) {
      case "INCREMENT":
        return !1 === n ? (0, l.nextValidIndex)(t, r, "INCREMENT") : r === o.length - 1 ? (0, l.nextValidIndex)(t, 0, "INCREMENT") : (0, l.nextValidIndex)(t, r + 1, "INCREMENT");

      case "DECREMENT":
        return !1 === n ? (0, l.nextValidIndex)(t, r, "DECREMENT") : 0 === r ? (0, l.nextValidIndex)(t, o.length - 1, "DECREMENT") : (0, l.nextValidIndex)(t, r - 1, "DECREMENT");

      default:
        return (0, l.nextValidIndex)(t, 0, "DECREMENT");
    }
  };
  var l = n(6);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e, t) {
    e.forEach(function (e) {
      e === t.keyCode && t.preventDefault();
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = {
    TAB: 9,
    ENTER: 13,
    SPACE: 32,
    ESCAPE: 27,
    UP: 38,
    DOWN: 40
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    var t = e.event,
        n = e.state,
        c = e.props,
        d = e.ReactResponsiveSelectClassRef,
        f = n.multiselect,
        p = n.isOptionsPanelOpen;
    if (n.disabled) return;
    (0, o.default)([l.default.ENTER, l.default.SPACE, l.default.ESCAPE, l.default.UP, l.default.DOWN], t), /^[a-z0-9]+$/.test(t.key) && (0, a.default)({
      event: t,
      ReactResponsiveSelectClassRef: d,
      state: n
    });

    switch (t.keyCode) {
      case l.default.TAB:
        p && (t.preventDefault(), f && d.updateState({
          type: r.SET_OPTIONS_PANEL_CLOSED
        }, function () {
          return d.focusButton();
        }));
        break;

      case l.default.ENTER:
        (0, i.default)({
          event: t,
          state: n,
          props: c,
          ReactResponsiveSelectClassRef: d
        });
        break;

      case l.default.SPACE:
        p ? (0, u.default)({
          event: t,
          state: n,
          ReactResponsiveSelectClassRef: d
        }) : d.updateState({
          type: r.SET_OPTIONS_PANEL_OPEN
        });
        break;

      case l.default.ESCAPE:
        d.updateState({
          type: r.SET_OPTIONS_PANEL_CLOSED_NO_SELECTION
        }, function () {
          return d.focusButton();
        });
        break;

      case l.default.UP:
        (0, s.default)({
          state: n,
          ReactResponsiveSelectClassRef: d,
          type: "DECREMENT"
        });
        break;

      case l.default.DOWN:
        (0, s.default)({
          state: n,
          ReactResponsiveSelectClassRef: d,
          type: "INCREMENT"
        });
    }
  };

  var l = c(n(43)),
      r = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t.default = e, t;
  }(n(0)),
      o = c(n(42)),
      a = c(n(12)),
      i = c(n(9)),
      u = c(n(10)),
      s = c(n(8));

  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e, t) {
    return String(e.className).split(" ").indexOf(t) > -1;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(n(4));

  t.default = function (e, t, n, r) {
    r && !(0, l.default)(e, t) && r({
      name: t.name,
      text: t.text,
      value: t.value,
      altered: n
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(n(4));

  t.default = function (e, t, n, r) {
    r && !(0, l.default)(e, t) && r({
      options: t.map(function (e) {
        return {
          name: e.name,
          text: e.text,
          value: e.value
        };
      }),
      altered: n
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    var t = e.state,
        n = e.ReactResponsiveSelectClassRef,
        o = e.props,
        a = t.isOptionsPanelOpen,
        i = t.disabled,
        u = t.altered,
        s = t.singleSelectSelectedOption,
        c = t.multiSelectSelectedOptions,
        d = o.onBlur,
        f = o.multiselect;
    if (i) return;
    var p = n.selectBox && !n.selectBox.contains(document.activeElement);
    a && p && n.updateState({
      type: l.SET_OPTIONS_PANEL_CLOSED_ONBLUR
    });
    p && d && (f ? (0, r.multiSelectBroadcastChange)(void 0, c.options, u, d) : (0, r.singleSelectBroadcastChange)(void 0, s, u, d));
  };

  var l = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t.default = e, t;
  }(n(0)),
      r = n(11);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.handleTouchStart = t.handleTouchMove = t.handleKeyUpOrDownPressed = t.handleKeyEvent = t.handleEnterPressed = t.handleClick = t.handleBlur = t.handleAlphaNumerical = void 0;
  var l = d(n(12)),
      r = d(n(48)),
      o = d(n(10)),
      a = d(n(9)),
      i = d(n(44)),
      u = d(n(8)),
      s = d(n(40)),
      c = d(n(39));

  function d(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  t.handleAlphaNumerical = l.default, t.handleBlur = r.default, t.handleClick = o.default, t.handleEnterPressed = a.default, t.handleKeyEvent = i.default, t.handleKeyUpOrDownPressed = u.default, t.handleTouchMove = s.default, t.handleTouchStart = c.default;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var l = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var l in n) Object.prototype.hasOwnProperty.call(n, l) && (e[l] = n[l]);
    }

    return e;
  },
      r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var l = t[n];
        l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(e, l.key, l);
      }
    }

    return function (t, n, l) {
      return n && e(t.prototype, n), l && e(t, l), t;
    };
  }(),
      o = n(5),
      a = m(o),
      i = m(n(4)),
      u = m(n(3)),
      s = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t.default = e, t;
  }(n(0)),
      c = n(49),
      d = n(11),
      f = n(2),
      p = m(n(31)),
      S = m(n(30)),
      _ = m(n(7)),
      O = m(n(29)),
      v = m(n(16)),
      b = m(n(14));

  function m(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var y = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var e = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));

      return e.state = _.default, e.reducer = O.default, e;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, o.Component), r(t, [{
      key: "componentDidMount",
      value: function value() {
        var e = this.props,
            t = e.options,
            n = e.noSelectionLabel,
            l = e.selectedValue,
            r = e.selectedValues,
            o = e.name,
            a = e.multiselect,
            i = e.disabled,
            u = e.altered;
        this.updateState({
          type: s.INITIALISE,
          value: {
            options: t,
            noSelectionLabel: n,
            selectedValue: l,
            selectedValues: r,
            name: o,
            multiselect: a,
            disabled: i,
            altered: u
          }
        });
      }
    }, {
      key: "componentWillReceiveProps",
      value: function value(e) {
        (0, i.default)(e, this.props) || this.updateState({
          type: s.UPDATE_VIA_PROPS,
          value: l({}, this.props, e)
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e, t) {
        var n = this.state,
            l = n.singleSelectSelectedOption,
            r = n.multiSelectSelectedOptions,
            o = n.multiselect,
            a = n.altered,
            i = this.props.onChange;
        return o ? (0, d.multiSelectBroadcastChange)(t.multiSelectSelectedOptions.options, r.options, a, i) : (0, d.singleSelectBroadcastChange)(t.singleSelectSelectedOption, l, a, i), !0;
      }
    }, {
      key: "updateState",
      value: function value(e, t) {
        var n = this.reducer(this.state, e);
        this.setState(n, function () {
          t && t(n);
        }), (0, p.default)(this.props.name, e, n);
      }
    }, {
      key: "focusButton",
      value: function value() {
        this.selectBox.querySelector(".rrs__button").focus();
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            t = this.props,
            n = t.prefix,
            l = t.caretIcon,
            r = t.disabled,
            o = this.state,
            i = o.altered,
            s = o.singleSelectInitialIndex,
            d = o.hasOptHeaders,
            f = o.isOptionsPanelOpen,
            p = o.isDragging,
            _ = o.noSelectionLabel,
            O = o.multiSelectInitialSelectedIndexes,
            m = o.multiSelectSelectedIndexes,
            y = o.multiSelectSelectedOptions,
            x = o.name,
            E = o.nextPotentialSelectionIndex,
            g = o.options,
            P = o.singleSelectSelectedIndex,
            h = o.singleSelectSelectedOption,
            I = o.multiselect,
            T = (0, S.default)({
          state: this.state,
          props: this.props
        });
        return a.default.createElement("div", {
          "data-name": x,
          className: (0, u.default)("\n          rrs\n          " + (!0 === f ? "rrs--options-visible" : "") + "\n          " + (i ? "rrs--has-changed" : "") + "\n          " + (d ? "rrs--has-opt-headers" : "") + " \n        "),
          ref: function ref(t) {
            e.selectBox = t;
          },
          tabIndex: "-1",
          onKeyDown: function onKeyDown(t) {
            return (0, c.handleKeyEvent)({
              event: t,
              ReactResponsiveSelectClassRef: e,
              state: e.state,
              props: e.props
            });
          },
          onTouchStart: function onTouchStart() {
            return (0, c.handleTouchStart)({
              ReactResponsiveSelectClassRef: e,
              state: e.state
            });
          },
          onTouchMove: function onTouchMove() {
            return (0, c.handleTouchMove)({
              ReactResponsiveSelectClassRef: e,
              state: e.state
            });
          },
          onTouchEnd: function onTouchEnd(t) {
            return (0, c.handleClick)({
              event: t,
              ReactResponsiveSelectClassRef: e,
              state: e.state
            });
          },
          onMouseDown: function onMouseDown(t) {
            return (0, c.handleClick)({
              event: t,
              ReactResponsiveSelectClassRef: e,
              state: e.state
            });
          },
          onBlur: function onBlur() {
            return (0, c.handleBlur)({
              ReactResponsiveSelectClassRef: e,
              state: e.state,
              props: e.props
            });
          }
        }, I ? a.default.createElement(v.default, {
          noSelectionLabel: _,
          disabled: r,
          altered: i,
          isDragging: p,
          caretIcon: l,
          customLabelText: T,
          prefix: n,
          name: x,
          multiSelectInitialSelectedIndexes: O,
          multiSelectSelectedOptions: y,
          multiSelectSelectedIndexes: m,
          nextPotentialSelectionIndex: E,
          isOptionsPanelOpen: f,
          options: g,
          selectBoxRef: this.selectBox
        }) : a.default.createElement(b.default, {
          noSelectionLabel: _,
          disabled: r,
          altered: i,
          isDragging: p,
          singleSelectInitialIndex: s,
          caretIcon: l,
          prefix: n,
          name: x,
          customLabelText: T,
          singleSelectSelectedOption: h,
          singleSelectSelectedIndex: P,
          nextPotentialSelectionIndex: E,
          isOptionsPanelOpen: f,
          options: g,
          selectBoxRef: this.selectBox
        }));
      }
    }]), t;
  }();

  t.default = y, y.propTypes = f.ReactResponsiveSelectProps;
}]);